import dayjs from 'dayjs';

import type {HourOfTheDay, Millisecond, MinuteOfTheHour} from '../Time';
import type {DayOfTheWeek} from './DayOfTheWeek';

export type TimeShiftResult = {
  day: DayOfTheWeek;
  hour: HourOfTheDay;
  minute: MinuteOfTheHour;
};

/**
 * @param _ Time in milliseconds since epoch
 * @param timezone Time zone name, like Europe/Moscow
 */
export default function shiftTimeByTimeZone(
  _: Millisecond,
  timezone: string,
): TimeShiftResult {
  const $ = dayjs(_).tz(timezone);
  return {
    day: $.day() as DayOfTheWeek,
    hour: $.hour() as HourOfTheDay,
    minute: $.minute() as MinuteOfTheHour,
  };
}
